<template>
	<screen class="update-user-view">
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">Update User</h2>
			</ui-header>
		</template>
		<div class="update-user-content">
			<form v-on:submit.prevent="onSubmit">
				<label>
					<ui-input
						v-model="user.first_name"
						placeholder="First Name"
					/>
					<div v-if="!user.first_name" class="needed">
						<i class="fas fa-exclamation-circle"></i>
					</div>
				</label>
				<label>
					<ui-input
						v-model="user.last_name"
						placeholder="Last Name"
					/>
					<div v-if="!user.last_name" class="needed">
						<i class="fas fa-exclamation-circle"></i>
					</div>
				</label>
				<label>
					<p v-if="this.message" v-bind:style="{ color: 'white' }">
						{{ this.message }}
					</p>
					<ui-input
						v-model="user.phone"
						placeholder="Phone"
						@input="onlyNumber($event)"
					/>
					<div v-if="!user.phone" class="needed">
						<i class="fas fa-exclamation-circle"></i>
					</div>
				</label>
				<label>
					<ui-input v-model="user.email" placeholder="Email" />
					<div v-if="!user.email" class="needed">
						<i class="fas fa-exclamation-circle"></i>
					</div>
				</label>
				<label>
					<ui-button native-type="submit" :loading="isLoading"
						>Save User</ui-button
					>
				</label>
			</form>
		</div>
		<div class="update-user-content" style="text-align: center">
			<a href="#" @click.prevent="close">Close Account</a>
		</div>
	</screen>
</template>

<script>
import { mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import UiButton from '../../ui/Button'
import UiHeader from '../../ui/Header'
import UiInput from '../../ui/Input'
import Screen from '../../ui/Screen'

export default {
	name: 'update-user-view',
	components: { Screen, UiButton, UiInput, UiHeader },
	data() {
		return {
			isLoading: false,
			user: {
				email: null,
				first_name: null,
				last_name: null,
				phone: null
			}
		}
	},
	methods: {
		...mapActions(['updateUser', 'closeAccount']),
		onSubmit() {
			this.isLoading = true
			const user = {
				email: this.user.email,
				phone: this.user.phone,
				first_name: this.user.first_name,
				last_name: this.user.last_name,
				minimum_donation: this.user.minimum_donation,
				whole_transaction_amount: this.user.whole_transaction_amount
			}
			this.updateUser(user)
				.then(() => {
					this.isLoading = false
					this.$swal(
						'Success',
						'Your information has successfully been updated.'
					)
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		},
		close() {
			if (
				confirm(
					"Are you sure you want to close your account? This action is permanent. Closing your account will remove RoundUp's access to your bank and remove your card information."
				)
			) {
				this.closeAccount()
					.then(() => {
						this.$swal(
							'Success',
							'Your account has been closed. Thank you for having been a part of RoundUp!'
						)
					})
					.catch(({ message }) => {
						this.isLoading = false
						this.$swal('Error', message)
					})
			}
		},
		onBack() {
			this.navigate({ name: 'settings' }, 'back')
		},
		onlyNumber(evt) {
			const clean = evt.replace(/\D+/g, '')
			if (clean !== evt) {
				this.message = 'Numbers only please :)'
			} else {
				this.message = null
			}
			this.user.phone = clean
		}
	},
	mounted() {
		this.user = cloneDeep(this.$store.state.me.current)
	}
}
</script>

<style lang="scss">
.update-user-view {
	.update-user-content {
		padding: 15px 0px;
	}
}
.needed {
	position: absolute;
	right: 10px;
	top: 10px;
	height: 15px;
	width: 15px;
	color: $red;
}
</style>
